import React from 'react';
import { Sparkles, Rocket, Wrench, Megaphone, PackageSearch, Globe, Stethoscope, LayoutGrid, CreditCard, Languages, ScanLine, Recycle, ShieldCheck, CalendarClock, ReceiptEuro, Boxes, Smartphone, Camera, ShoppingCart, Mail, Archive } from 'lucide-react';
import { useT } from '../context/LanguageContext';

const VERSIES = [
  {
    versie: 'v2.11', datum: 'Oktober 2026', icon: Archive, kleur: '#0d9488', titel: 'Voertuigen archiveren & verkopen op de bon',
    items: [
      'Voertuig archiveren: heeft een klant zijn auto niet meer? Archiveer hem (met reden: verkocht, gesloopt, andere garage of overig) via de klantkaart of de APK-lijst. De historie blijft bewaard, maar de auto verdwijnt uit APK & Onderhoud, herinneringen en het klantportaal en kan niet meer op nieuwe bonnen. Terugzetten kan altijd',
      'Nieuwe knop "Uit verkoop" bij het maken van een bon: kies een verkocht onderdeel (bijv. via webshop of Marktplaats), een verkochte handelauto zonder bon, of een onderdeel direct uit voorraad — de regel wordt ingevuld en automatisch aan de bon gekoppeld',
      'Onderdelen uit voorraad worden bij opslaan van de bon automatisch op "Verkocht" gezet; haal je de regel weer weg, dan gaat het onderdeel terug naar voorraad',
    ],
  },
  {
    versie: 'v2.10', datum: 'Juli 2026', icon: Mail, kleur: '#2563eb', titel: 'Meer omzet & minder handwerk',
    items: [
      'Wekelijks weekoverzicht per e-mail: elke maandagochtend een samenvatting met je omzet van de week, openstaande facturen en welke APK\'s binnenkort verlopen — aan/uit te zetten via Instellingen → Algemeen, plus een knop op het dashboard om het meteen te versturen',
      'Automatisch review-verzoek: vraag klanten na een betaalde factuur automatisch om een Google-recensie (met je eigen reviewlink) — in te stellen via Instellingen → Reviews, inclusief reviewlog en handmatig verzoek per factuur',
      'Offerte-conversie op het dashboard: zie in één oogopslag welk percentage van je offertes is omgezet naar een werkbon/factuur, zodat je gerichter kunt opvolgen',
      'Betaalherinneringen met "Betaal online"-link: openstaande facturen kun je via e-mail herinneren mét directe Stripe-betaallink, voor snellere betaling',
      'APK-datums automatisch actueel: alle kentekens worden dagelijks bij de RDW gecontroleerd en bijgewerkt, met een handmatige "verversen"-knop op het dashboard en de APK-pagina',
      'Afspraakherinneringen via e-mail (zonder Twilio nodig)',
    ],
  },
  {
    versie: 'v2.9', datum: 'Juni 2026', icon: ReceiptEuro, kleur: '#0d9488', titel: 'E-facturatie & BTW-aangifte automatiseren',
    items: [
      'Peppol/e-facturatie: verstuur je facturen écht over het Peppol-netwerk via Storecove — vul je API-sleutel in en het werkt direct (zonder sleutel maak je gewoon de UBL-download)',
      'BTW-aangifte via Digipoort: dien je kwartaalaangifte rechtstreeks in bij de Belastingdienst zodra je je PKIoverheid-certificaat instelt (veilig standaard uit — zonder certificaat blijft het bij "voorbereiden + XBRL-download")',
      'Automatische status-opvolging: na indiening volgt MonteurCentraal de verwerkingsstatus en mailt je automatisch zodra de aangifte is geslaagd of afgekeurd',
      'Onboarding slimmer: optionele integraties (Stripe, WhatsApp/SMS, Peppol) kun je op "Niet gebruiken" zetten — geen onnodige rode vinkjes meer, en bij een volledige setup verschijnt een "Setup compleet"-melding en verdwijnt de checklist',
    ],
  },
  {
    versie: 'v2.8', datum: 'Juni 2026', icon: Languages, kleur: '#2563eb', titel: 'Meertalig & internationaal bereik',
    items: [
      'Volledige Engelse interface: schakel de hele app met één klik om naar het Engels — direct en vloeiend, zonder wachten',
      'Publieke showroom & boekingspagina herkennen automatisch de taal van je bezoeker (Nederlands, Engels, Duits) en tonen de site meteen in de juiste taal',
      'Bezoekers kunnen zelf van taal wisselen via een duidelijke taalkeuze; een melding laat zien wanneer de taal automatisch is gekozen',
      'Nieuw: "Deel"-knop in de showroom — deel je occasions in één tik via WhatsApp of kopieer de link',
    ],
  },
  {
    versie: 'v2.7', datum: 'Juni 2026', icon: Camera, kleur: '#a855f7', titel: 'Slimme onderdelen-invoer met AI',
    items: [
      'Foto\'s uploaden → AI herkent het onderdeel en vult automatisch naam, categorie, merk, nummers, conditie en prijs in',
      'AI prijsadvies-badge: zie in één oogopslag of je vraagprijs onder, op of boven de marktprijs ligt (incl. adviesvraagprijs)',
      'Donor-sloopauto koppelen vanuit de onderdeelkaart — vult automatisch "afkomstig van", kenteken, merk en bouwjaar',
      'Advertentie maken (AI) direct vanuit de onderdeelkaart, zonder eerst op te slaan en opnieuw te openen',
      'Nieuw: knop "Plaats op Facebook" — kopieert titel + tekst, downloadt je foto\'s en opent Facebook Marketplace (veilig plakken, geen API-risico)',
      '"Past op"-check werkt nu ook met aftermarket-merken (Ridex, Febi, Bosch…) via OEM cross-reference',
      'Streepjes-/QR-code scannen: naast de camera kun je nu ook een foto van de code uploaden (handig zonder webcam)',
    ],
  },
  {
    versie: 'v2.6', datum: 'Juni 2026', icon: Smartphone, kleur: '#0ea5e9', titel: 'Mobiele app & installeerbaar (PWA)',
    items: [
      'MonteurCentraal is nu installeerbaar als app op telefoon, tablet en pc ("Zet op beginscherm")',
      'Volledig mobiele weergave: schuif-menu (hamburger), overzichtelijke kaarten in plaats van brede tabellen en grote knoppen',
      'Werkt vlot op de werkvloer — alle pagina\'s (dashboard, planning, werkkaarten, klanten, voertuigen, onderdelen, handel, facturen) zijn responsive',
      'Eigen app-icoon en offline-melding bij geen verbinding',
    ],
  },
  {
    versie: 'v2.5', datum: 'Juni 2026', icon: ShoppingCart, kleur: '#16a34a', titel: 'Inkoop, handel & extra AI-tools',
    items: [
      'Inkooporder ontvangen → vrije regels worden automatisch als nieuw voorraad-artikel aangemaakt (met OEM-nr en verkoopadvies)',
      'Handel: flip-calculatie per auto (kostprijs, netto marge, ROI% en dagen in voorraad) + afvinkbare RDW-titelchecklist',
      'Betalingen: (deel)betaling per factuur bewerken/verwijderen rechtstreeks vanuit "Openstaande bonnen"',
      'Nieuw: AI Foutcode-uitleg (OBD/DTC → oorzaken, onderdelen, arbeidstijd)',
      'Nieuw: AI Offerte-assistent (klacht → kant-en-klare offerteregels met richtprijzen)',
    ],
  },
  {
    versie: 'v2.4', datum: 'Juni 2026', icon: ShieldCheck, kleur: '#0d9488', titel: 'APK & Onderhoud',
    items: [
      'Nieuwe module "APK & Onderhoud" met APK-vervalwaarschuwingen (verlopen / binnenkort) per voertuig',
      'Onderhoudsinterval per auto (maanden + km) met automatische berekening van de volgende beurt',
      'APK-voorkeuring checklist (14 controlepunten) — afdrukbaar voor de klant',
      'Terugroepacties / recalls registreren; het systeem markeert automatisch de getroffen voertuigen',
      'E-mailherinnering voor APK rechtstreeks naar de klant',
    ],
  },
  {
    versie: 'v2.3', datum: 'Juni 2026', icon: ReceiptEuro, kleur: '#16a34a', titel: 'Professionele facturatie',
    items: [
      'Creditfactuur met 1 klik (negatieve factuur, gekoppeld aan het origineel)',
      'Deelfactuur / termijn + aanbetaling en kilometerstand op de factuur',
      'Betaal-QR (SEPA) op de factuur — klant scant en betaalt met de bankapp, geen provider nodig',
      'Factuurnummers per jaar (F-2026-0001 …) met automatische reset per jaar',
      'Export voor de boekhouder (CSV met alle facturen & creditfacturen)',
    ],
  },
  {
    versie: 'v2.2', datum: 'Juni 2026', icon: CalendarClock, kleur: '#2563eb', titel: 'Werkplaatsplanning',
    items: [
      'Bruggen / werkplekken toewijzen (instelbaar aantal) + monteur per klus',
      'Tijdinschatting per klus en werkstatus (wacht op onderdelen / bezig / klaar / opgehaald)',
      'Sleepbare kalender: versleep een afspraak naar een ander tijdslot',
      'Capaciteitswaarschuwing bij dubbele boeking (zelfde brug of monteur)',
      'Dagplanning afdrukken, gegroepeerd per brug',
    ],
  },
  {
    versie: 'v2.1', datum: 'Juni 2026', icon: Boxes, kleur: '#0ea5e9', titel: 'Onderdelenhandel Pro',
    items: [
      'QR-magazijnlabels per onderdeel (afdrukken) + onderdeel terugvinden via camera-scan',
      'Past-op lijst (merk/model/bouwjaar) en OEM cross-reference (alternatieve nummers)',
      'Minimum voorraad met "bijbestellen"-waarschuwing + boekhoudkundige voorraadwaarde',
      'Inkoopbron/leverancier, retourstatus en garantie per onderdeel',
      'Uitgebreider fotobeheer met hoofdfoto-keuze',
    ],
  },
  {
    versie: 'v2.05', datum: 'Juni 2026', icon: Stethoscope, kleur: '#7c3aed', titel: 'AI Diagnose met controle',
    items: [
      'AI Diagnose werkt nu in 2 stappen: AI stelt voor → jij controleert → daarna pas opslaan',
      'Geen enkele AI-data wordt meer zonder jouw bevestiging weggeschreven',
      'Bewerkbaar controlescherm met betrouwbaarheids-indicatoren per veld',
    ],
  },
  {
    versie: 'v2.0', datum: 'Juni 2026', icon: Languages, kleur: '#2563eb', titel: 'AI Advertentiemaker Pro',
    items: [
      '🌍 AI-vertalen: vertaal de hele advertentie naar 8 talen (NL/EN/DE/FR/PL/ES/IT/TR) — natuurlijk, geen letterlijke vertaling',
      'Werkt voor álle voertuigtypes: auto, camper, caravan, aanhanger, scooter, brommer, motor, vrachtwagen, oldtimer',
      'Pluspunten & onderhoud (distributieriem, nieuwe APK/banden/remmen, sleutels, onderhoudshistorie) worden in de tekst verwerkt',
      'Kenteken + tot 6 foto\'s → AI herkent opties en schade en bepaalt de marktwaarde in één stap',
      'Eerlijke vermelding van schade/aandachtspunten + sterke/verbeterpunten',
    ],
  },
  {
    versie: 'v1.9', datum: 'Juni 2026', icon: ScanLine, kleur: '#0d9488', titel: 'Autopapieren scannen met AI',
    items: [
      'Voeg een voertuig toe zónder kenteken: maak een foto van de autopapieren',
      'Werkt ook met buitenlandse documenten (bv. Duitse Zulassungsbescheinigung)',
      'AI leest merk, model, bouwjaar, VIN, brandstof en voertuigtype automatisch in',
      'Beschikbaar bij klantvoertuigen, auto handel én de advertentiemaker',
    ],
  },
  {
    versie: 'v1.8', datum: 'Juni 2026', icon: Recycle, kleur: '#16a34a', titel: 'Sloopvoertuigen & beveiliging',
    items: [
      'Sloop/demontage voor alle voertuigtypes: auto, scooter, motor, aanhanger, caravan en meer',
      'Automatische onderdelenlijst per type (scooter: kuipdelen/variomatic, aanhanger: as/dissel, caravan: keuken/koelkast…)',
      'Showroom-link nu ook terug te vinden in Instellingen → Algemeen',
      'Verbeterde beveiliging: versleutelde SMTP-wachtwoorden en strengere toegang',
    ],
  },
  {
    versie: 'v1.7', datum: 'Juni 2026', icon: Megaphone, kleur: '#a855f7', titel: 'AI-advertentie voor onderdelen',
    items: [
      'Genereer met AI een verkoopadvertentie voor losse onderdelen (Marktplaats, Facebook en forum)',
      'Indicatieve marktprijs, verkoopkans, verwachte winst en sterke/verbeterpunten',
      'AI-fotoanalyse: herkent staat, schade en kenmerken van het onderdeel',
      'Direct vanuit de advertentie publiceren in je showroom',
    ],
  },
  {
    versie: 'v1.6', datum: 'Juni 2026', icon: Globe, kleur: '#7c3aed', titel: 'Publieke Showroom',
    items: [
      'Eigen publieke verkooppagina: monteurcentraal.com/showroom/jouw-garage',
      'Auto-advertenties met één klik publiceren (concept / gepubliceerd / verwijderen)',
      'Onderdelen publiceren vanuit de voorraad',
      'Occasion- en onderdeel-detailpagina met WhatsApp, bellen, e-mail en afspraak',
      'Statistieken: bezoekers, meest bekeken, contactaanvragen, WhatsApp-kliks, verkocht',
    ],
  },
  {
    versie: 'v1.5', datum: 'Juni 2026', icon: PackageSearch, kleur: '#0ea5e9', titel: 'Onderdelenhandel',
    items: [
      'Voorraadbeheer voor gebruikte & nieuwe onderdelen (onderdelenkaart + foto\'s)',
      'Sloopauto markeren → automatisch een onderdelenlijst genereren',
      'Zoeken op kenteken, OEM, nummer, merk; voorraadwaarde & verkoophistorie',
    ],
  },
  {
    versie: 'v1.4', datum: 'Juni 2026', icon: Megaphone, kleur: '#a855f7', titel: 'AI Advertentie-generator',
    items: [
      'Verkoopadvertentie voor Marktplaats, AutoScout24 en Facebook in 4 stijlen',
      'RDW-data + APK automatisch in de tekst, indicatieve marktprijs & vraagprijs-meter',
      'Foto-analyse, winstberekening, verkoopscore, verwachte verkooptijd en concurrentie',
      'Aparte "Advertentie maken"-tool: kenteken invullen en klaar',
    ],
  },
  {
    versie: 'v1.3', datum: 'Juni 2026', icon: Stethoscope, kleur: '#16a34a', titel: 'AI Diagnose',
    items: ['Upload een diagnoserapport (PDF) → AI maakt klant, voertuig en werkbon met uitleg'],
  },
  {
    versie: 'v1.2', datum: 'Juni 2026', icon: Languages, kleur: '#0284c7', titel: 'Meertaligheid, online afspraken & boekhouding',
    items: [
      'Volledig instelbare meertaligheid met AI-vertaling (Google Gemini) — vertaal de hele app naar elke taal',
      'Online afspraken: publieke boekingspagina (monteurcentraal.com/afspraak/jouw-garage) met diensten, tijdsloten en RDW-check',
      'Boekhoud-suite: Debiteurenbeheer, Kosten/inkoopfacturen, automatische herinneringen, BTW & Winst, Grootboek en Balans',
      'Bankafschrift-import (MT940 / CAMT.053) met automatisch matchen aan facturen en kosten',
    ],
  },
  {
    versie: 'v1.1', datum: 'Februari–Mei 2026', icon: CreditCard, kleur: '#7c3aed', titel: 'Licenties, plannen & cloud',
    items: [
      'Pricing-tiers (Basic / Pro / Enterprise / Lifetime) met onkraakbare cryptografische licenties',
      'Webshop: pakketten bestellen, betalen (bank/PayPal) en automatische licentie-uitgifte',
      'E-mailactivatie bij registratie + wachtwoord-reset (Resend)',
      'Cloud-synchronisatie van documenten (Dropbox & Google Drive)',
      'Apparaatbeheer + activatielogboek per licentie (misbruikbeveiliging)',
    ],
  },
  {
    versie: 'v1.0', datum: 'Januari–Februari 2026', icon: LayoutGrid, kleur: '#ea580c', titel: 'De basis: complete garage-software',
    items: [
      'Dashboard met omzet-KPI\'s, openstaande facturen, planning en voorraad-alerts',
      'Klanten, voertuigen & voertuighistorie met RDW-kentekencheck en VIN-lookup (NHTSA)',
      'Bonnen & facturen met eigen logo, BTW/hobby-modus en print/PDF',
      'Betalingen, Auto handel, Planning, Meldingen (APK), Onderdelen, Rapportage, Documenten en Werkkaart',
      'Multi-tenant: elk garagebedrijf volledig gescheiden, multi-user met eigen rollen',
    ],
  },
];

export default function InfoPagina() {
  const { t } = useT();
  return (
    <div className="space-y-4" data-testid="info-page" style={{ maxWidth: 760 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Rocket size={22} color="#7c3aed" />
        <div><h2 style={{ margin: 0 }}>{t('Wat is nieuw', 'Wat is nieuw')}</h2>

        <p style={{ margin: 0, fontSize: 13, color: 'var(--cs-text-muted)' }}>{t('Functies en versies van MonteurCentraal', 'Functies en versies van MonteurCentraal')}</p></div>
      </div>

      <div style={{ position: 'relative', paddingLeft: 8 }}>
        {VERSIES.map((v, i) => (
          <div key={i} className="cs-card padded" style={{ marginBottom: 14 }} data-testid={`info-versie-${v.versie}`}>
            <div style={{ marginBottom: 10 }}>
              <div style={{ fontWeight: 800, fontSize: 16 }}>{t(v.titel, v.titel)}</div>
              <div style={{ fontSize: 12, color: 'var(--cs-text-muted)' }}><span style={{ fontWeight: 700, color: v.kleur }}>{v.versie}</span> · {t(v.datum, v.datum)}
              </div>
            </div>
            
            
            <ul style={{ margin: 0, paddingLeft: 20, color: 'var(--cs-text)', fontSize: 13.5, lineHeight: 1.8 }}>
              {v.items.map((it, j) => (
                <li key={j}>{t(it, it)}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
